<template>
  <div id="categories-list">
    <v-snackbar
      v-model="isSnackbarVisible"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
      auto-height
    >
      <v-layout
        align-center
        pr-4
      >
        <v-icon
          class="pr-3"
          dark
          large
        >
          {{ snackbar.icon == 'success' ? icons.mdiCheckBold : icons.mdiCheckBold }}
        </v-icon>

        <v-layout column>
          <div>
            <strong>{{ snackbar.title }}</strong>
          </div>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
    </v-snackbar>

    <!-- titulo -->
    <h2 class="m-2">
      NUEVA ORDEN
    </h2>

    <!-- modal 2 MULTIPUNTOS -->

    <v-card>
      <v-form @submit.prevent="saveData2">
        <v-card-title>
          <span class="headline"></span>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <!-- Columna 1 y 2: Inputs y selectores -->
              <v-col cols="12" md="8">
                <v-row>
                  <v-col cols="6">
                    <label>Fecha orden</label><br />
                    <label class="dark">{{ row.fecha_orden }}</label>
                  </v-col>

                  <v-col cols="6">
                    <v-autocomplete
                      v-model="row.cliente_id"
                      required
                      :items="customersList"
                      label="Buscar cliente"
                      dense
                      item-text="nombre"
                      item-value="id"
                      autocomplete="off"
                      clearable
                      hide-no-data
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="6">
                    <v-select
                      v-model="row.tipo"
                      :items="tipoPedido"
                      label="Tipo de pedido"
                      dense
                      item-text="nombre"
                      item-value="id"
                    ></v-select>
                  </v-col>

                  <v-col cols="6">
                    <input
                      id="address-search"
                      ref="origin"
                      class="form-control"
                      type="text"
                      placeholder="Buscar dirección"
                    />
                    <small>{{ address }}</small>
                  </v-col>

                  <v-col cols="6">
                    <v-text-field
                      v-model="rowAddress.direccionExacta"
                      label="Dirección exacta"
                      dense
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6">
                    <v-text-field
                      v-model="rowAddress.telefono"
                      label="Teléfono"
                      dense
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6">
                    <v-text-field
                      v-model="rowAddress.detalle"
                      label="Detalle"
                      dense
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6">
                    <v-text-field
                      v-model="rowAddress.descripcion"
                      label="¿Qué hacemos en el punto?"
                      dense
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6">
                    <v-text-field
                      v-model="rowAddress.total_arecaudar"
                      label="Total a recaudación"
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6">
                    <v-btn color="secondary" @click="agregarPunto()">
                      Agregar punto
                    </v-btn>
                  </v-col>

                  <!-- Puntos agregados -->
                  <v-col cols="12">
                    <v-divider class="my-2"></v-divider>
                    <h4>Puntos agregados</h4>
                    <div v-if="orden.puntos.length > 0">
                      <v-chip
                        v-for="(punto, index) in orden.puntos"
                        :key="index"
                        class="ma-1"
                        close
                        @click:close="removePoint(punto)"
                      >
                        Punto {{ String.fromCharCode(65 + index) }}: {{ punto.direccion }}
                      </v-chip>
                    </div>
                    <div v-else>
                      <small>No hay puntos agregados</small>
                    </div>
                  </v-col>

                  <!-- Datos financieros -->
                  <v-col cols="4">
                    <v-text-field
                      v-model="row.deposito"
                      label="Depósito"
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="row.banco"
                      label="Banco"
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="row.numero_cuenta"
                      label="Número de cuenta"
                      dense
                    ></v-text-field>
                  </v-col>

                  <!-- Calcular total -->
                  <v-col cols="6">
                    <v-btn color="secondary" @click="calcularPrecioApp()">
                      Calcular total
                    </v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="row.total"
                      label="Total"
                      dense
                      type="number"
                      prefix="C$"
                    ></v-text-field>
                  </v-col>

                  <v-col v-if="calculos" cols="12">
                    <v-alert dense type="info">{{ calculos }}</v-alert>
                  </v-col>

                  <v-col cols="6">
                    <v-text-field
                      label="Estado"
                      dense
                      readonly
                      value="En espera"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="row.metodo_pago"
                      :items="metodoPago"
                      label="Método de pago"
                      dense
                      item-text="nombre"
                      item-value="nombre"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>

              <!-- Columna 3: Mapa -->
              <v-col cols="12" md="4">
                <div style="height: 500px; position: sticky; top: 0;">
                  <google-map
                    id="map1"
                    :center="centerM"
                    :zoom="14"
                    style="width: 100%; height: 100%"
                    :pan-to="panTo"
                    @click="addPoint($event)"
                  >
                    <GmapMarker
                      v-for="(m, index) in coordinates"
                      :key="index"
                      :position="m.position"
                      @click="center = m.position"
                    />
                  </google-map>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            @click="isDialogVisible2 = false"
          >
            Cerrar
          </v-btn>
          <v-btn
            type="submit"
            color="success"
          >
            <!-- @click="isDialogVisible = false" -->
            Guardar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import {
  mdiCheckBold, mdiDeleteOutline, mdiMapSearch, mdiPencil, mdiPlusCircle,
} from '@mdi/js'
import { ref } from '@vue/composition-api'

import {
  MglGeojsonLayer, MglGeolocateControl, MglMap, MglMarker, MglNavigationControl, MglPopup,
} from 'vue-mapbox'

// import VueGmaps from 'vue-gmaps'

export default {
  components: {
    MglMap,
    MglMarker,
    MglGeojsonLayer,
    MglNavigationControl,
    MglGeolocateControl,
    MglPopup,
  },
  data() {
    return {
      icons: {
        mdiDeleteOutline, mdiPencil, mdiPlusCircle, mdiCheckBold, mdiMapSearch,
      },
      items: [],
      table: 'ordenes',
      tableColumns: [
        { text: 'id', value: 'id', sortable: true },
        { text: 'Fecha Orden', value: 'fecha_orden', sortable: true },
        { text: 'Fecha Finalizado', value: 'fecha_finalizado', sortable: true },
        { text: 'Total', value: 'total', sortable: true },
        { text: 'Estado', value: 'estado', sortable: true },
        { text: 'Acciones', value: 'acciones', sortable: false },

        // {id:0, name:}
      ],
      loading: false,
      totalItems: 0,
      isDialogVisible: false,
      row: {
        coordenadas_inicio: '',
        coordenadas_entrega: '',
        total: 0,
        tipo: 0,
        deposito: 0,
      },
      modalTitle: 'Nueva Orden',
      customersList: [],
      categoriesList: [],
      subcategoriesList: [],
      commerceList: [],
      formHasErrors: false,
      errorMessages: '',
      form: ref(null),
      valid: ref(true),
      isSnackbarVisible: false,
      message: '',
      messageColor: 'primary',
      icon: '',
      snackbar: {
        color: 'success',
        icon: 'check_circle',
        mode: 'multi-line',
        title: 'Success',
        text: 'That worked, hoorah.',
        visible: true,
      },
      statusList: [{ nombre: 'En espera' }, { nombre: 'Inactivo' }],
      tipoPedido: [
        { id: 1, nombre: 'Enviar a traer desde mi ubicación' },
        { id: 2, nombre: 'Multi Puntos' },
      ],
      calculos: '',
      distanciaViaje: 0,
      metodoPago: [{ nombre: 'Tarjeta de C.' }, { nombre: 'Efectivo' }],

      accessToken: 'pk.eyJ1IjoicGVkaWRvc3lhIiwiYSI6ImNsMnNkNGl4ODBqaDgzZW8zN3VvY2c1YWMifQ.sOFdwHG62peplh1SCnpxgQ',
      googleToken: 'AIzaSyAcjiwmtcAvLbb7J8X5rxDoWWmVEYJTUGA', // 'pk.eyJ1IjoicGVkaWRvc3lhIiwiYSI6ImNsMnNkNGl4ODBqaDgzZW8zN3VvY2c1YWMifQ.sOFdwHG62peplh1SCnpxgQ',
      mapStyle: 'mapbox://styles/mapbox/streets-v11',
      stateList: [{ name: 'Activo' }, { name: 'Pendiente' }],

      geojson: {
        type: 'FeatureCollection',
        features: [
          {
            properties: { name: 'south park' },
            geometry: {
              coordinates: [-95.2358865737915, 38.96194491354418],
            },
          },
          {
            properties: { name: 'Buford M Watson, Jr. Park' },
            geometry: {
              coordinates: [-95.23893356323242, 38.97148792405487],
            },
          },
        ],
      },
      layerId: 'firstLayer',
      sourceId: 'firstSource',
      coordinates: [],
      center: [-86.108508886867, 11.912447380368315],
      centerM: { lat: 11.912447380368315, lng: -86.108508886867 },
      zoom: 8,
      showMapa: 0,
      coordenadas: '',
      tipocoord: 0,
      isDialogVisible2: false,
      coordenadasMultipunto: [],
      calculosMultipuntos: [],
      address: '',
      addressList: [],
      elMapa: null,
      rowAddress: { total_arecaudar: 0 },
      cliente: '',
      place_id: '',
      panTo: {},

      /// /*css*/`
      orden: {
        propina: 0,
        puntos: [],
      },

    }
  },
  async mounted() {
    this.row.fecha_orden = this.$moment().format('DD-MM-YYYY HH:MM:ss')
    
    setTimeout(() => {
      const addressInput = document.getElementById('address-search')
      console.log('Buscando input:', addressInput)
      if (addressInput && window.google) {
        const options = {
          componentRestrictions: { country: 'ni' },
        }
        const autocomplete = new google.maps.places.Autocomplete(addressInput, options)
        
        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace()
          console.log('Place seleccionado:', place)
          if (place.place_id) {
            this.place_id = place.place_id
            this.buscarDirecciones(place)
          }
        })
        console.log('Autocomplete inicializado correctamente')
      } else if (!window.google) {
        console.error('Google Maps API no está cargada')
      } else {
        console.error('Input de dirección no encontrado')
      }
    }, 500)

    await this.getData()
    await this.getCategories()
    await this.getCommerce()
    await this.getCustomers()
  },
  methods: {
    addPoint(e) {
      const data = JSON.parse(JSON.stringify(e))

      // data =
      console.log('ee', data)

      // let dd = {lat:data.latLng.lat, lng:data.latLng.lng}
      // this.centerM = { lat: data.latLng.lat, lng: data.latLng.lng }
      this.panTo = { lat: data.latLng.lat, lng: data.latLng.lng }
      this.row.coordenadas_inicio = `${data.latLng.lat},${data.latLng.lng}`
      this.coordinates = []
      this.coordinates.push({ position: this.panTo })
    },
    getAddressData(addressData, placeResultData, id) {
      this.address = addressData
    },
    async centerAndAnimate(lat, lng) {
      try {
        console.log('actualizando, centrando y animando camara')
        this.center = `${lat}, ${lng}`

        // this.elMapa.map.setCenter({
        // this.elMapa.map.setCenter({
        //   lat: lat, //52.3602160, // mandatory
        //   lng: lng, //4.8891680, // mandatory
        //   animated: true, // default true,
        //   zoomLevel: 20,
        // })
        // this.elMapa.map.animateCamera({
        //   // this is where we animate to
        //   target: {
        //     lat: lat,
        //     lng: lng,
        //   },
        //   zoomLevel: 15.5, // Android
        //   //altitude: 2000, // iOS (meters from the ground)
        //   //bearing: 270, // Where the camera is pointing, 0-360 (degrees)
        //   tilt: 50,
        //   duration: 2000, // default 10000 (milliseconds)
        // })
        return true
      } catch (error) {
        console.log('error', error)

        return false
      }
    },
    async onMapReady(args) {
      console.log('mapa leido')
      this.elMapa = args

      // await centerAndAnimate(args, this.lat, this.lng)
    },
    async seleccionarDireccion(item) {
      const lista = [...this.addressList]
      const pos = lista.find(x => x.center == item)
      this.rowAddress.direccionExacta = pos.name
      console.log('posición', pos)
      console.log(item)
      this.row.coordenadas_inicio = `${item[1]},${item[0]}`
      this.coordinates = []
      this.coordenadas = `${item[0]},${item[1]}`
      const data = { coordinates: JSON.parse(`[${this.coordenadas}]`), cliente_id: 1 }
      this.coordinates.push(data)

      // await this.centerAndAnimate(item[0], item[1])
    },

    async buscarDirecciones(place) {
      console.log('buscarDirecciones llamado', place)
      
      if (!place) {
        console.log('No hay place, usando place_id:', this.place_id)
        const request = {
          placeId: this.place_id,
          fields: ['name', 'geometry', 'address_components'],
        }
        const service = new google.maps.places.PlacesService(document.createElement('div'))
        
        service.getDetails(request, (placeResult, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            this.procesarPlace(placeResult)
          } else {
            console.error('Error getting place details:', status)
          }
        })
      } else {
        this.procesarPlace(place)
      }
    },
    procesarPlace(place) {
      console.log('Procesando place:', place)
      try {
        const location = place.geometry.location
        const lat = location.lat()
        const lng = location.lng()
        
        this.address = [lat, lng]
        this.centerM = { lat, lng }
        this.row.coordenadas_inicio = `${lat},${lng}`
        this.coordinates.push({ position: { lat, lng } })
        
        let direccion = place.name || ''
        if (place.address_components) {
          const componentes = place.address_components
          const obtenerTipo = (tipo) => {
            const comp = componentes.find(c => c.types.includes(tipo))
            return comp ? comp.long_name : ''
          }
          
          const calle = obtenerTipo('street_number') + ' ' + obtenerTipo('route')
          const ciudad = obtenerTipo('locality')
          const departamento = obtenerTipo('administrative_area_level_1')
          
          direccion = [calle, ciudad, departamento].filter(Boolean).join(', ')
        }
        
        this.rowAddress.direccionExacta = direccion || place.formatted_address
        console.log('Dirección procesada:', this.rowAddress.direccionExacta)
      } catch (e) {
        console.error('Error procesando place:', e)
      }
    },
    async calcularPrecioApp() {
      try {
        console.log('calculando precio')
        this.distanciaViaje = 0
        this.calculos = ''

        if (!this.orden.puntos || this.orden.puntos.length < 2) {
          this.mostrarToast('Error!', 'Debes agregar al menos 2 puntos!', 'error')
          return
        }

        const resTarifas = await this.$store.dispatch('get', { path: 'tarifas/getById/1' })
        console.log('===== TARIFAS =====')
        console.log('base_menora6km:', resTarifas.base_menora6km)
        console.log('base_mayoroiguala6km:', resTarifas.base_mayoroiguala6km)
        console.log('mtsminimo:', resTarifas.mtsminimo)
        console.log('precio_x_cada_punto_multipuntos:', resTarifas.precio_x_cada_punto_multipuntos)
        console.log('==================')

        console.log('===== PUNTOS =====')
        console.log('Cantidad de puntos:', this.orden.puntos.length)
        this.orden.puntos.forEach((p, idx) => {
          console.log(`Punto ${idx}:`, p)
        })
        console.log('==================')

        let distanciaTotal = 0
        let tiempoTotal = 0

        for (let i = 1; i < this.orden.puntos.length; i++) {
          const punto = this.orden.puntos[i]
          const puntoAnterior = this.orden.puntos[i - 1]
          console.log('Punto', i, punto)

          const coordInicio = puntoAnterior.coordenadas_entrega
          const coordFin = punto.coordenadas_entrega

          console.log('Coord inicio:', coordInicio, 'Coord fin:', coordFin)

          if (!coordInicio || !coordFin || coordInicio === coordFin) {
            console.log('Coordenadas iguales o incompletas en punto', i, coordInicio, coordFin)
            continue
          }

          try {
            console.log('Llamando API con:', coordInicio, '->', coordFin)
            const dataCoord = await this.getDataCoords(coordInicio, coordFin)
            const resp = await dataCoord.json()
            console.log('Respuesta API:', resp)

            if (!resp.routes || !resp.routes[0]) {
              console.log('No hay rutas para el punto', i)
              continue
            }

            const tiempoViaje = (resp.routes[0].duration.toFixed(0) / 60).toFixed(2)
            const distanciaPunto = resp.routes[0].distance

            distanciaTotal += distanciaPunto
            tiempoTotal += parseFloat(tiempoViaje)

            this.orden.puntos[i].tiempo_viaje = tiempoViaje
            this.orden.puntos[i].distancia_viaje = distanciaPunto
            this.orden.puntos[i].calculos = `Distancia: ${distanciaPunto}m, Tiempo: ${tiempoViaje}min`
            console.log('Distancia punto:', distanciaPunto, 'Tiempo:', tiempoViaje)
          } catch (e) {
            console.log('Error calculando punto', i, e)
          }
        }

        console.log('Distancia total calculada:', distanciaTotal)

        this.distanciaViaje = distanciaTotal
        console.log('Distancia total:', distanciaTotal)
        console.log('Puntos:', this.orden.puntos.length)

        let total = 0
        if (this.orden.puntos.length > 4) {
          total = (this.orden.puntos.length - 1) * Number(resTarifas.precio_x_cada_punto_multipuntos)
          console.log('Calculando por puntos:', total)
        } else {
          if (distanciaTotal < resTarifas.mtsminimo) {
            total = Number(resTarifas.base_menora6km) + (this.orden.propina != null ? Number(this.orden.propina) : 0)
            console.log('Calculando base < 6km:', total)
          } else {
            total = Number(distanciaTotal) * Number(resTarifas.base_mayoroiguala6km)
              + Number(resTarifas.precio_x_retirar)
              + Number(resTarifas.publicidad)
              + Number(resTarifas.precio_x_deposito)
              + Number(resTarifas.precio_x_entregar)
              + (this.orden.propina != null ? Number(this.orden.propina) : 0)
              + Number(resTarifas.precio_x_lluvia)
              + Number(resTarifas.precio_mas_6pm)
              + Number(resTarifas.precio_x_trafico)
            console.log('Calculando distancia > 6km:', total)
          }
        }

        this.row.total = parseFloat(total.toFixed(2))
        this.calculos = `Distancia aprox.: ${distanciaTotal} m., Tiempo aprox.: ${tiempoTotal.toFixed(2)} min.`

        console.log('Total calculado:', this.row.total)
      } catch (error) {
        console.log('error in calculo', error)
        this.mostrarToast('Error!', 'Error al calcular precio. Verifica los puntos.', 'error')
      }
    },
    async calcularPrecioMultipuntos() {
      console.log('************ iniciando calculos ***************')
      console.log(this.calculosMultipuntos)

      // obtener distancia, tiempo etc.
      this.calculosMultipuntos = []
      this.loading = true
      let contador1 = 0
      let contador2 = 1
      const limite = this.coordenadasMultipunto.length - 1

      // agregar el primer registro, sin precioxdistancia, distanciaviaje,etc

      this.calculosMultipuntos.push({
        id: 0,
        tiempo_viaje: 0,
        distancia_viaje: 0,
        precio_x_distancia: 0,
        total: 0,
        calculos: '--',
        coordenadas_inicio: '',
        coordenadas_entrega: this.coordenadasMultipunto[contador1].coordenadas,
        direccion: this.coordenadasMultipunto[contador1].nombre,
        telefono: this.coordenadasMultipunto[contador1].telefono,
        descripcion: this.coordenadasMultipunto[contador1].descripcion,
      })
      const resTarifas = await this.$store.dispatch('get', { path: 'tarifas/getById/1' })
      let contadorit = 1
      for (let ii = 0; ii < limite; ii++) {
        console.log(
          `${ii}-`,
          this.coordenadasMultipunto[contador1].coordenadas,
          ',',
          this.coordenadasMultipunto[contador2].coordenadas,
        )
        const dataCoord = await this.getDataCoords(
          this.coordenadasMultipunto[contador1].coordenadas,
          this.coordenadasMultipunto[contador2].coordenadas,
        )
        const resp = await dataCoord.json()
        const tiempoViaje = (resp.routes[0].duration.toFixed(0) / 60).toFixed(2)
        const distanciaViaje = resp.routes[0].distance // < 1000 ? resp.routes[0].distance.toFixed(2)  : (resp.routes[0].distance / 1000).toFixed(2)
        console.log('dataco', tiempoViaje)
        console.log('dataco', distanciaViaje)

        console.log('resTarifas', resTarifas)
        const precio_x_distancia = distanciaViaje < 5 ? resTarifas.precio_x_metro_30_max : resTarifas.precio_x_metro_60_max
        const total = Number(distanciaViaje) * precio_x_distancia
          + resTarifas.precio_x_retirar
          + resTarifas.publicidad
          + resTarifas.precio_x_deposito
          + resTarifas.precio_x_entregar
        this.calculosMultipuntos.push({
          id: contadorit,
          tiempo_viaje: tiempoViaje,
          distancia_viaje: distanciaViaje,
          precio_x_distancia,
          total,
          calculos: `Distancia aprox.: ${distanciaViaje} m., Tiempo aprox.: ${tiempoViaje} min.`,
          coordenadas_inicio: this.coordenadasMultipunto[contador1].coordenadas,
          coordenadas_entrega: this.coordenadasMultipunto[contador2].coordenadas,
          direccion: this.coordenadasMultipunto[contador2].nombre,
          telefono: this.coordenadasMultipunto[contador2].telefono,
          descripcion: this.coordenadasMultipunto[contador2].descripcion,
        })

        contador1++
        contador2++
        contadorit++
      }

      // pintando puntos en mapa
      this.coordinates = []
      for await (const itm of this.coordenadasMultipunto) {
        let cc1 = itm.coordenadas
        cc1 = cc1.split(',')

        this.coordenadas = `${cc1[1]}, ${cc1[0]}`

        // this.row.coordenadas_inicio = event.mapboxEvent.lngLat.lat + ',' + event.mapboxEvent.lngLat.lng
        const data = { coordinates: JSON.parse(`[${this.coordenadas}]`), cliente_id: 1 }
        this.coordinates.push(data)
      }

      /// //////
      console.log('for out -->', this.calculosMultipuntos)
      const total = 0

      /// ///////////////////////////
      if (this.coordenadasMultipunto.length > 2) {
        this.row.total = (this.coordenadasMultipunto.length - 1) * Number(resTarifas.precio_x_cada_punto_multipuntos)

        // console.log("calculando puntos....", this.total);
      } else {
        this.row.total = this.calculosMultipuntos
          .reduce((a, b) => a + b.total, 0)
          .toFixed(2)
      }

      /// ////////////////////

      this.loading = false
    },
    removePoint(item) {
      console.log('eliminando', item)
      const itt = [...this.orden.puntos]
      console.log('cc', itt)
      const result = itt.indexOf(item)
      console.log('eliminando', result)
      if (result > -1) {
        this.orden.puntos.splice(result, 1)
      }
    },
    clickMapaMultipuntos(event) {
      this.coordinates = []
      this.coordenadas = `${event.mapboxEvent.lngLat.lng}, ${event.mapboxEvent.lngLat.lat}`
      this.row.coordenadas_inicio = `${event.mapboxEvent.lngLat.lat},${event.mapboxEvent.lngLat.lng}`

      const data = { coordinates: JSON.parse(`[${this.coordenadas}]`), cliente_id: 1 }
      this.coordinates.push(data)
    },
    mostrarToast(titulo, mensaje, tipo) {
      this.snackbar = {
        color: tipo,
        icon: tipo,
        mode: 'multi-line',
        title: titulo,
        text: mensaje, // 'Debes seleccionar coordenada / dirección!',
        timeout: '2500',
      }
      this.isSnackbarVisible = true
    },
    async agregarPunto() {
      try {
        console.log('agregando punto....')
        if (this.row.tipo == 0 || this.row.tipo == null) {
          this.mostrarToast('Error!', 'Debes seleccionar tipo de orden!.', 'error')

          return
        }
        if (this.coordenadasMultipunto.length == 2 && this.row.tipo == 1) {
          this.mostrarToast('Error!', 'Si quieres agregar más puntos selecciona multipuntos!', 'error')

          return
        }
        if (this.row.cliente_id == 0 || this.row.cliente_id == null) {
          this.mostrarToast('Error!', 'Debes seleccionar Cliente', 'error')

          return
        }
        if (this.row.coordenadas_inicio == '' || this.row.coordenadas_inicio == null) {
          this.mostrarToast('Error!', 'Debes seleccionar coordenada / dirección!', 'error')

          return
        }
        if (this.rowAddress.detalle == '' || this.rowAddress.detalle == null) {
          this.mostrarToast('Error!', 'Falta detalle!', 'error')

          return
        }
        if (this.rowAddress.direccionExacta == '' || this.rowAddress.direccionExacta == null) {
          this.mostrarToast('Error!', 'Falta dirección!', 'error')

          return
        }
        if (this.rowAddress.telefono == '' || this.rowAddress.telefono == null) {
          this.mostrarToast('Error!', 'Falta teléfono!', 'error')

          return
        }

        // let arrTmp = [...this.coordenadasMultipunto]
        // console.log('ejecutar', arrTmp)
        // let contador = await (this.coordenadasMultipunto == null || this.coordenadasMultipunto == []
        //   ? 1
        //   : this.coordenadasMultipunto.length++)
        // let itt1 = {
        //   id: contador,
        //   coordenadas: this.row.coordenadas_inicio
        // }
        /// ///////////////
        const orden = { ...this.orden }
        const contador = orden.puntos.length
        const data = {
          id: contador,
          tiempo_viaje: 0,
          distancia_viaje: 0,
          precio_x_distancia: 0,
          total: 0,
          calculos: '--',
          coordenadas_inicio: contador == 0 ? this.row.coordenadas_inicio : this.orden.puntos[contador - 1].coordenadas_entrega,
          coordenadas_entrega: this.row.coordenadas_inicio,
          direccion: this.rowAddress.direccionExacta,
          telefono: this.rowAddress.telefono,
          descripcion: this.rowAddress.detalle,
          nombre: this.rowAddress.direccionExacta,
          total_arecaudar: this.rowAddress.total_arecaudar,

        }
        orden.puntos.push(data)
        this.orden = orden
        console.log('coordenadasmultipunto ---->', this.orden)

        // localStorage.setItem("nuevaorden", JSON.stringify(this.orden));
        /// ////////////////

        // arrTmp.push({
        //   id: contador,
        //   coordenadas: this.row.coordenadas_inicio,
        //   descripcion: this.rowAddress.detalle,
        //   telefono: this.rowAddress.telefono,
        //   nombre: this.rowAddress.direccionExacta,
        // })
        // this.coordenadasMultipunto.splice(nu,1)
        // let cconta = 0
        // for await (let iit of arrTmp) {
        // console.log('ii ', iit)
        // if (iit == undefined) {
        //   arrTmp.splice(cconta, 1)
        // }
        // cconta++
        // }
        // this.coordenadasMultipunto = arrTmp
      } catch (error) {
        console.log('error', error)
      }
    },
    async saveData2() {
      try {
        if (this.orden.puntos.length < 2) {
          this.mostrarToast('Error!', 'Debes agregar más puntos!', 'error')

          return
        }
        if (this.row.metodo_pago == 0 || this.row.metodo_pago == null) {
          this.mostrarToast('Error!', 'Debes selecionar método de pago.', 'error')

          return
        }
        if (this.row.total == 0 || this.row.total == null) {
          this.mostrarToast('Error!', 'Debes calcular total.', 'error')

          return
        }
        const fecha = new Date()
        this.row.fecha_orden = this.$moment(fecha).utc()
        const row = { ...this.row }
        let res

        // if (row.id) {
        //   delete row.id
        //   delete row.categoria
        // res = await this.$store.dispatch('put', { path: 'multipuntos/modify/' + this.row.id, data: row })
        // } else {
        delete row.coordenadas_inicio
        const data = {
          datos: row,
          puntos: this.orden.puntos,
        }
        res = await this.$store.dispatch('post', { path: '/multipuntos/new/', data })

        // }
        // this.getData()
        this.snackbar = {
          color: 'success',
          icon: 'success',
          mode: 'multi-line',
          title: 'Muy bien!',
          text: 'Registro procesado correctamente!.',
          timeout: '2500',
        }
        this.isDialogVisible = false
        this.isSnackbarVisible = true
        console.log(res)
      } catch (error) {
        console.log(error)
      }
    },
    mapClicked(event) {
      // alert('click')
      console.log(event)

      // console.log(event.mapboxEvent.lngLat.lng+ ','+event.mapboxEvent.lngLat.lat)
      this.coordinates = []
      this.coordenadas = `${event.mapboxEvent.lngLat.lng}, ${event.mapboxEvent.lngLat.lat}`

      // this.coordenadas_ubicacion = this.coordenadas
      if (this.tipocoord == 1) this.row.coordenadas_inicio = `${event.mapboxEvent.lngLat.lat},${event.mapboxEvent.lngLat.lng}`

      if (this.tipocoord == 2) this.row.coordenadas_entrega = `${event.mapboxEvent.lngLat.lat},${event.mapboxEvent.lngLat.lng}`

      const data = { coordinates: JSON.parse(`[${this.coordenadas}]`), cliente_id: 1 }

      // vector["coordinates"]=item.ubicacion
      this.coordinates.push(data)
    },
    showMap(type) {
      this.coordinates = []
      this.showMapa = !this.showMapa
      this.tipocoord = type
    },
    async getDataCoords(cc1, cc2) {
      const accessToken = 'sk.eyJ1IjoicGVkaWRvc3lhIiwiYSI6ImNsMnNqNWNyMTNmM3IzY2x3ZnNxeW41emEifQ.V0rqflXEzObaf5pgjOa0gA'
      const co1 = cc1.split(',')
      const co2 = cc2.split(',')
      console.log(co1)
      console.log(co2)
      const lng1 = co1[1]
      const lat1 = co1[0]
      const lng2 = co2[1]
      const lat2 = co2[0]

      const endPoint = `https://api.mapbox.com/directions/v5/mapbox/driving-traffic/${lng1}%2C${lat1}%3B${lng2}%2C${lat2}?alternatives=true&geometries=geojson&language=en&overview=simplified&steps=true&access_token=sk.eyJ1IjoicGVkaWRvc3lhIiwiYSI6ImNsMnNqNWNyMTNmM3IzY2x3ZnNxeW41emEifQ.V0rqflXEzObaf5pgjOa0gA`

      // consumir servicio
      // console.log('endPoint ////////////////////////',endPoint)
      const queryCal = await fetch(endPoint, { method: 'GET' })

      return queryCal
    },
    async calcularPrecio() {
      // obtener distancia, tiempo etc.
      this.loading = true
      const dataCoord = await this.getDataCoords(this.row.coordenadas_inicio, this.row.coordenadas_entrega)
      const resp = await dataCoord.json()
      const tiempoViaje = (resp.routes[0].duration.toFixed(0) / 60).toFixed(2)
      this.distanciaViaje = resp.routes[0].distance // < 1000 ? resp.routes[0].distance.toFixed(2)  : (resp.routes[0].distance / 1000).toFixed(2)

      console.log('dataco', tiempoViaje)
      console.log('dataco', this.distanciaViaje)

      const resTarifas = await this.$store.dispatch('get', { path: 'tarifas/getById/1' })
      console.log('resTarifas', resTarifas)
      this.loading = false
      const precio_x_distancia = this.distanciaViaje < 5 ? resTarifas.precio_x_metro_30_max : resTarifas.precio_x_metro_60_max
      this.row.total = Number(this.distanciaViaje) * precio_x_distancia
        + resTarifas.precio_x_retirar
        + resTarifas.publicidad
        + resTarifas.precio_x_deposito
        + resTarifas.precio_x_entregar
      this.calculos = `Distancia aprox.: ${this.distanciaViaje} m., Tiempo aprox.: ${tiempoViaje} min.`

      // obtener tarifas para calcular precio
    },
    async saveData() {
      try {
        // pendiente la validación del form
        // this.formHasErrors = false
        const row = { ...this.row }

        // console.log('row', row)

        // Object.keys(row).forEach(f => {
        //   if (f == 'nombre') {
        //     if (!row[f]) this.formHasErrors = true

        //     this.$refs[f].validate(true)
        //   }
        // })
        ///
        let res
        if (row.id) {
          // es update
          delete row.id
          delete row.categoria
          res = await this.$store.dispatch('put', { path: `${this.table}/modify/${this.row.id}`, data: row })
        } else {
          res = await this.$store.dispatch('post', { path: `${this.table}/new/`, data: this.row })

          // es post
        }
        this.getData()
        this.snackbar = {
          color: 'success',
          icon: 'success',
          mode: 'multi-line',
          title: 'Muy bien!',
          text: 'Registro procesado correctamente!.',
          timeout: '2500',
        }

        this.isDialogVisible = false
        this.isSnackbarVisible = true
        console.log(res)
      } catch (error) {
        console.log(error)
      }
    },
    showModal(type, item) {
      if (type == 1) {
        this.modalTitle = 'Nueva orden'
        this.row = {
          coordenadas_inicio: '',
          coordenadas_entrega: '',
        }

        // this.calculos= ''
        this.calculos = ''
        this.isDialogVisible = true
      }
      if (type == 2) {
        this.row = item
        this.modalTitle = 'Editar orden'
        this.calculos = ''
        this.isDialogVisible = true
      }
      if (type == 3) {
        this.row = {
          coordenadas_inicio: '',
          coordenadas_entrega: '',
        }
        this.modalTitle = 'Nueva orden'
        this.calculos = ''
        this.isDialogVisible = false
        this.isDialogVisible2 = true
      }
    },
    async getData() {
      try {
        this.loading = true
        const res = await this.$store.dispatch('get', { path: `${this.table}/getAll/` })
        this.loading = false
        if (res.length > 0) {
          this.items = res
          this.totalItems = this.items.length
        }
      } catch (error) {
        this.items = []
        this.loading = false
        console.error('error', error)
      }
    },
    async getCustomers() {
      try {
        this.loading = true
        const res = await this.$store.dispatch('get', { path: 'clientes/getAll/' })
        this.loading = false
        if (res.length > 0) {
          console.log(res)
          this.customersList = res
        }
      } catch (error) {
        this.customersList = []
        this.loading = false
        console.error('error', error)
      }
    },
    async getCommerce() {
      try {
        this.loading = true
        const res = await this.$store.dispatch('get', { path: 'comercios/getAll/' })
        this.loading = false
        if (res.length > 0) {
          console.log(res)
          this.commerceList = res
        }
      } catch (error) {
        this.commerceList = []
        this.loading = false
        console.error('error', error)
      }
    },
    async getCategories() {
      try {
        this.loading = true
        const res = await this.$store.dispatch('get', { path: 'categorias/getAll/' })
        this.loading = false
        if (res.length > 0) {
          console.log(res)
          this.categoriesList = res
        }
      } catch (error) {
        this.categoriesList = []
        this.loading = false
        console.error('error', error)
      }
    },
    async getSubcategoriesByCategory(category_id) {
      try {
        console.log('sel', category_id)
        this.loading = true
        const res = await this.$store.dispatch('get', { path: `subcategorias/getAllByCategory/${category_id}` })
        this.loading = false
        if (res.length > 0) {
          console.log(res)
          this.subcategoriesList = res
        } else {
          this.subcategoriesList = []
          this.row.subcategoria_id = 0
        }
      } catch (error) {
        this.subcategoriesList = []
        this.loading = false
        console.error('error', error)
      }
    },
    async deleteData(item) {
      try {
        let txt
        if (confirm('¿Eliminar Registro?')) {
          this.loading = true
          const res = await this.$store.dispatch('delete', { path: `${this.table}/${item.id}` })
          await this.getData()
          this.loading = false
          txt = 'You pressed OK!'
          this.snackbar = {
            color: 'success',
            icon: 'success',
            mode: 'multi-line',
            title: 'Muy bien!',
            text: 'Registro elimiado correctamente!.',
            timeout: '2500',
          }
          this.isSnackbarVisible = true
        } else {
          // txt = 'You pressed Cancel!'
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';

.form-control {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
}
</style>
